const messages = {
  it: {
    custom: {
      email: {
        required: 'Il campo email è obbligatorio.',
        email: 'Il campo email deve essere un indirizzo email valido.'
      },
      name: {
        required: 'Il campo nome è obbligatorio.'
      },
      surname: {
        required: 'Il campo cognome è obbligatorio.'
      },
      message: {
        required: 'Il campo messaggio è obbligatorio.'
      },
      privacy: {
        required: 'Devi aver letto e accettato le condizioni sulla tutela della privacy.'
      }
    }
  },
  en: {
    custom: {
      email: {
        required: 'The email field is required.',
        email: 'The email field must be a valid email.'
      },
      name: {
        required: 'The name field is required.'
      },
      surname: {
        required: 'The surname field is required.'
      },
      message: {
        required: 'The message field is required.'
      },
      privacy: {
        required: 'You must accept the therms of the privacy policy.'
      }
    }
  }
}

export default messages
